import React, { useState, useEffect } from 'react';
import Lottie from "lottie-react";
import Header from '../components/Header';
import Hero from '../components/Hero';
import Departments from '../components/Departments';
import Leadership from '../components/Leadership';
import Projects from '../components/Projects';
import GovernmentDirectorates from '../components/GovernmentDirectorates';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import Certificate from '../components/Certificate';
import ScrollIndicator from '../components/ScrollIndicator';
import AdminInterface from '../components/AdminInterface';
import '../assets/styles/main.css';

// Import your animation JSON
import animationData from './C2pQSUe2Q8.json';

function Home() {
  const [showAdmin, setShowAdmin] = useState(false);
  const [projectsData, setProjectsData] = useState({
    live: [],
    completed: []
  });
  const [loading, setLoading] = useState(true);
  const [showAnimation, setShowAnimation] = useState(true); // splash state

  // Run splash animation for 7 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowAnimation(false);
    }, 7000);
    return () => clearTimeout(timer);
  }, []);

  // Load projects from backend API
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await fetch('https://alafoogarage.com/ahalafoo/api/projects');
        if (response.ok) {
          const data = await response.json();
          setProjectsData(data);
        } else {
          console.error('Failed to fetch projects');
          setProjectsData({ live: [], completed: [] });
        }
      } catch (error) {
        console.error('Error fetching projects:', error);
        setProjectsData({ live: [], completed: [] });
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  // Keyboard shortcut for admin interface
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.key === 'd') {
        e.preventDefault();
        setShowAdmin(true);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  const handleUpdateProjects = () => {
    const fetchProjects = async () => {
      try {
        const response = await fetch('https://alafoogarage.com/ahalafoo/api/projects');
        if (response.ok) {
          const data = await response.json();
          setProjectsData(data);
        }
      } catch (error) {
        console.error('Error fetching projects after update:', error);
      }
    };

    fetchProjects();
  };

  // 🔥 Show splash animation first
  if (showAnimation) {
    return (
      <div
        className="splash-screen"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          background: "#fff",
          textAlign: "center"
        }}
      >
        <Lottie
          animationData={animationData}
          loop={false}
          style={{ width: 300, height: 300 }}
        />
        <h2 style={{ marginTop: "20px", fontSize: "1.5rem", color: "#333" }}>
          Work in progress...
        </h2>
      </div>
    );
  }

  // Show loading fallback if data is still fetching (after splash ends)
  if (loading) {
    return <div className="loading">Loading projects...</div>;
  }

  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <GovernmentDirectorates />
        <Departments />
        <Projects projects={projectsData} onUpdateProjects={handleUpdateProjects} />
        <Leadership />
        <Certificate />
        <Contact />
      </main>
      <Footer />
      <ScrollIndicator />

      <AdminInterface
        isOpen={showAdmin}
        onClose={() => setShowAdmin(false)}
        projects={projectsData}
        onUpdateProjects={handleUpdateProjects}
      />
    </div>
  );
}

export default Home;
